'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const dialog = "_dialog_1u4up_1";
const styles = {
	dialog: dialog
};

const DialogBase = (_a) => {
  var { children, className, style } = _a, props = tslib_es6.__rest(_a, ["children", "className", "style"]);
  const state = React.useContext(reactAriaComponents.OverlayTriggerStateContext);
  const close = React__default.default.useCallback(() => state === null || state === void 0 ? void 0 : state.close(), [state]);
  return jsxRuntime.jsx(reactAriaComponents.Dialog, Object.assign({ "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"], className: clsx__default.default(styles.dialog, className), "data-zds": true, style }, props, { children: typeof children === "function" ? children({ close }) : children }));
};

exports.DialogBase = DialogBase;
//# sourceMappingURL=DialogBase.cjs.js.map
